// BOOLEAN TO BINARY
export const bin = (booleanValue: boolean) => {
  return booleanValue ? 1 : 0;
};
